module.exports = __webpack_public_path__ + "img/audit_wait.f806e12b.png";